<div class="overFlowXNone" [dir]="this.app.getUserDire()">
    <div class="d-flex justify-content-between p-2">
        <div></div>
        <p class="interP m-0">{{ 'social.insights' | translate }}</p>
        <mat-icon (click)="cancel()" class="xIcon material-symbols-outlined pointer">cancel</mat-icon>
    </div>

    <hr>

    <div class="p-3">

        <div class="mb-4 d-flex">

            <div *ngIf="insights?.postMedia && insights?.postMedia[0]?.mediaType == 1" class="d-inline-block">
                <img class="border-less" [src]="app.getUserImage(insights?.postMedia[0]?.mediaFilePath)" alt="User Image">
            </div>

            <div class="mx-2 pt-2 w-100">
                <div>
                    <p class="yourReportP">{{insights?.postText}}</p>
                    <div class="d-flex justify-content-between">
                        <div>
                            <p class="text-center m-0 numP">{{insights?.likesCount}}</p>
                            <mat-icon class="iconS">favorite_outlined</mat-icon>
                        </div>
                        <div>
                            <p class="text-center m-0 numP">{{insights?.commentsCount}}</p>
                            <mat-icon class="iconS">chat_bubble_outlined</mat-icon>
                        </div>

                        <div>
                            <p class="text-center m-0 numP">{{insights?.savesCount}}</p>
                            <mat-icon class="iconS">bookmark_outlined</mat-icon>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="row mb-4">
            <div class="col-6">
                <p class="mainP">{{ 'SearchDoctor.Overview' | translate }}</p>
                <div class="d-flex justify-content-between">
                    <p>{{ 'social.accReached' | translate }}</p>
                    <p>{{insights?.reachCount}}</p>
                </div>

                <div class="d-flex justify-content-between">
                    <p>{{ 'social.accEng' | translate }}</p>
                    <p>{{insights?.accountEngaged}}</p>
                </div>

                <div class="d-flex justify-content-between">
                    <p>{{ 'social.accActiv' | translate }}</p>
                    <p>{{insights?.profileActivity}}</p>
                </div>

            </div>

            <div class="col-6">
                <p class="mainP">{{ 'social.postInter' | translate }}</p>
                <div class="d-flex justify-content-between">
                    <p>{{ 'social.likes' | translate }}</p>
                    <p>{{insights?.likesCount}}</p>
                </div>

                <div class="d-flex justify-content-between">
                    <p>{{ 'social.comments' | translate }}</p>
                    <p>{{insights?.commentsCount}}</p>
                </div>

                <div class="d-flex justify-content-between">
                    <p>{{ 'social.saved' | translate }}</p>
                    <p>{{insights?.savesCount}}</p>
                </div>

            </div>

        </div>

        <div *ngIf="!app.isContributor" class="px-5">
            <button (click)="dialogBoost()" class="btn mat-chip w-100">{{ 'social.boostPost' | translate }}</button>
        </div>

    </div>
</div>